import request from '../utils/axios/index'

export function siteLeaveAdd(data) {
  return request({
    url: '/rest/siteLeaveAnonymous/add',
    method: 'post',
    data
  })
}
